/* Veyralum theme scripts — vanilla, no dependencies */
(function(){
  document.documentElement.classList.remove('no-js');
  var PREVIEW = !!window.AU_PREVIEW;
  var money = function(cents){
    var fmt = (window.AU && window.AU.moneyFormat) || '€{{amount_with_comma_separator}}';
    var v = (cents/100).toFixed(2);
    var comma = v.replace('.',',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100));
  };

  /* header */
  var header = document.querySelector('.au-header');
  if(header){
    var onScroll = function(){ header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  }
  var burger = document.querySelector('.au-burger');
  var nav = document.querySelector('.au-nav');
  if(burger && nav){
    var scrim = document.querySelector('.au-nav-scrim');
    var setNav = function(open){ nav.classList.toggle('is-open', open); if(scrim) scrim.classList.toggle('is-open', open); burger.classList.toggle('is-open', open); burger.setAttribute('aria-expanded', open); };
    burger.addEventListener('click', function(){ setNav(!nav.classList.contains('is-open')); });
    if(scrim) scrim.addEventListener('click', function(){ setNav(false); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && nav.classList.contains('is-open')){ setNav(false); burger.focus(); } });
    nav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setNav(false); }); });
  }

  /* reveal */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('.au-reveal');
  if('IntersectionObserver' in window && !reduce){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, {rootMargin:'0px 0px -8% 0px'});
    revealEls.forEach(function(el){ io.observe(el); });
  } else { revealEls.forEach(function(el){ el.classList.add('is-in'); }); }

  /* spectrum */
  document.querySelectorAll('[data-au-spectrum]').forEach(function(root){
    var stage = root.querySelector('.au-spectrum__stage');
    var label = root.querySelector('[data-au-spectrum-label]');
    var swatches = root.querySelectorAll('.au-spot');
    var panels = root.querySelectorAll('[data-au-panel]');
    var select = function(i){
      swatches.forEach(function(s,j){ s.setAttribute('aria-pressed', i===j ? 'true':'false'); });
      panels.forEach(function(p,j){ p.hidden = i!==j; });
      var c = swatches[i].style.getPropertyValue('--c') || swatches[i].dataset.color;
      if(stage){ stage.style.setProperty('--au-sel', c); if(swatches[i].dataset.x) stage.style.setProperty('--au-x', swatches[i].dataset.x); }
      if(label) label.textContent = swatches[i].dataset.name;
    };
    swatches.forEach(function(s,i){
      var pick = function(){ root.dataset.touched = '1'; stopAuto(); select(i); };
      s.addEventListener('mouseenter', pick); s.addEventListener('focus', pick); s.addEventListener('click', pick);
    });
    var idx = 0, timer = null;
    var stopAuto = function(){ if(timer){ clearInterval(timer); timer=null; } };
    if(!reduce && 'IntersectionObserver' in window){
      var sio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting && !timer && !root.dataset.touched){
            timer = setInterval(function(){ idx = (idx+1)%swatches.length; select(idx); }, 2600);
          } else if(!e.isIntersecting){ stopAuto(); }
        });
      }, {threshold:.4});
      sio.observe(root);
      root.addEventListener('pointerdown', function(){ root.dataset.touched = '1'; stopAuto(); });
    }
    if(swatches.length) select(0);
  });

  /* product form */
  document.querySelectorAll('[data-au-product]').forEach(function(root){
    var dataEl = root.querySelector('script[data-au-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = root.querySelector('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = root.querySelector('[data-au-price]');
    var compareEl = root.querySelector('[data-au-compare]');
    var mainImg = root.querySelector('[data-au-main-img]');
    var thumbs = root.querySelectorAll('.au-thumb');
    var btn = root.querySelector('[data-au-add]');
    var btnLabel = btn ? btn.querySelector('[data-au-add-label]') : null;
    var sticky = document.querySelector('.au-sticky');
    var stickyPrice = sticky ? sticky.querySelector('[data-au-sticky-price]') : null;
    var stickyName = sticky ? sticky.querySelector('[data-au-sticky-name]') : null;

    var setMain = function(src, alt){
      if(!mainImg || !src) return;
      mainImg.style.opacity = .3;
      var im = new Image(); im.onload = function(){ mainImg.src = src; if(alt) mainImg.alt = alt; mainImg.style.opacity = 1; }; im.src = src;
      thumbs.forEach(function(t){ t.setAttribute('aria-current', t.dataset.src === src ? 'true':'false'); });
    };
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ setMain(t.dataset.src, t.dataset.alt); }); });

    var update = function(vid, initial){
      var v = variants.find(function(x){ return String(x.id) === String(vid); });
      if(!v) return;
      if(idInput) idInput.value = v.id;
      if(priceEl) priceEl.textContent = money(v.price);
      if(compareEl){ if(v.compare_at_price && v.compare_at_price > v.price){ compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if(v.image && !initial) setMain(v.image);
      if(btn){ btn.disabled = !v.available; if(btnLabel) btnLabel.textContent = v.available ? (btn.dataset.labelAdd || 'Add to cart') : (btn.dataset.labelSoldout || 'Sold out'); }
      if(stickyPrice) stickyPrice.textContent = money(v.price);
      var opt = root.querySelector('[data-au-option]');
      if(opt){
        var ot = opt.querySelector('[data-au-option-text]'), on = opt.querySelector('[data-au-option-name]');
        if(v.desc){ if(ot) ot.textContent = v.desc; if(on) on.textContent = v.title; opt.hidden = false; if(!initial){ opt.classList.remove('is-fresh'); void opt.offsetWidth; opt.classList.add('is-fresh'); } }
        else { opt.hidden = true; }
      }
      if(stickyName) stickyName.textContent = String(v.name || v.title).split(' / ')[0];
      if(!PREVIEW && window.history && window.history.replaceState && root.dataset.updateUrl === 'true'){
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
    };
    root.querySelectorAll('input[name="au-set"]').forEach(function(r){
      r.addEventListener('change', function(){ update(r.value); });
    });
    var checked = root.querySelector('input[name="au-set"]:checked');
    if(checked) update(checked.value, true);

    /* qty */
    var qty = root.querySelector('.au-qty input');
    root.querySelectorAll('.au-qty button').forEach(function(b){
      b.addEventListener('click', function(){
        var n = parseInt(qty.value||'1',10) + (b.dataset.dir === 'up' ? 1 : -1);
        qty.value = Math.max(1, Math.min(99, n));
      });
    });

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        if(btn){ btn.disabled = true; if(btnLabel) btnLabel.textContent = btn.dataset.labelAdding || 'Adding…'; }
        var payload = { id: parseInt(idInput.value,10), quantity: parseInt(qty ? qty.value : 1,10) || 1 };
        AUCart.add(payload).then(function(){
          document.dispatchEvent(new CustomEvent('cart:add', { detail: payload }));
          AUCart.open();
        }).catch(function(err){ alert((err && err.description) || 'Something went wrong. Please try again.'); })
        .finally(function(){ var v = variants.find(function(x){ return String(x.id) === String(idInput.value); }); if(btn){ btn.disabled = v ? !v.available : false; if(btnLabel) btnLabel.textContent = btn.dataset.labelAdd || 'Add to cart'; } });
      });
    }

    /* sticky visibility */
    if(sticky && btn && 'IntersectionObserver' in window){
      var stIO = new IntersectionObserver(function(es){ es.forEach(function(e){ sticky.classList.toggle('is-visible', !e.isIntersecting); }); });
      stIO.observe(btn);
      var stBtn = sticky.querySelector('.au-btn');
      if(stBtn) stBtn.addEventListener('click', function(ev){ var t = root.querySelector('[data-au-opts], .au-sets') || root; ev.preventDefault(); var y = t.getBoundingClientRect().top + window.pageYOffset - 90; window.scrollTo({top: y, behavior: 'smooth'}); });
    }
  });

  /* cart */
  var drawer = document.querySelector('.au-drawer');
  var mock = { items: [], item_count: 0, total_price: 0 };
  var AUCart = window.AUCart = {
    get: function(){
      if(PREVIEW) return Promise.resolve(mock);
      return fetch((window.AU && window.AU.routes.cart_url || '/cart') + '.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
    },
    add: function(p){
      if(PREVIEW){
        var v = (window.AU_PREVIEW_VARIANTS || []).find(function(x){ return x.id === p.id; });
        var line = mock.items.find(function(l){ return l.id === p.id; });
        if(line){ line.quantity += p.quantity; } else if(v){ mock.items.push({ id: v.id, key: String(v.id), product_title: window.AU_PREVIEW_TITLE, variant_title: v.name, quantity: p.quantity, final_price: v.price, image: v.image }); }
        recalc(); return Promise.resolve(mock);
      }
      return fetch((window.AU && window.AU.routes.cart_add_url || '/cart/add') + '.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[p] }) })
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); });
    },
    change: function(key, quantity){
      if(PREVIEW){
        mock.items = mock.items.filter(function(l){ if(l.key === key){ l.quantity = quantity; } return l.quantity > 0; });
        recalc(); return Promise.resolve(mock);
      }
      return fetch((window.AU && window.AU.routes.cart_change_url || '/cart/change') + '.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: key, quantity: quantity }) }).then(function(r){ return r.json(); });
    },
    open: function(){ if(!drawer){ window.location.href = '/cart'; return; } render().then(function(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; var c = drawer.querySelector('.au-drawer__close'); if(c) c.focus(); }); },
    close: function(){ if(!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  };
  function recalc(){ mock.item_count = mock.items.reduce(function(a,l){ return a+l.quantity; },0); mock.total_price = mock.items.reduce(function(a,l){ return a+l.quantity*l.final_price; },0); }

  function setCount(n){ document.querySelectorAll('[data-au-cart-count]').forEach(function(el){ el.textContent = n; }); }

  function render(){
    return AUCart.get().then(function(cart){
      setCount(cart.item_count);
      if(!drawer) return cart;
      var inCart = cart.items.map(function(l){ return String(l.variant_id || l.id); });
      var ups = drawer.querySelector('.au-drawer__upsell');
      if(ups){ var vis = 0; ups.querySelectorAll('[data-au-upsell]').forEach(function(r){ var hide = inCart.indexOf(r.dataset.auUpsell) > -1 || vis >= 3; r.hidden = hide; if(!hide) vis++; }); ups.hidden = vis === 0 || !cart.items.length; }
      var list = drawer.querySelector('.au-drawer__items');
      var total = drawer.querySelector('[data-au-cart-total]');
      var foot = drawer.querySelector('.au-drawer__foot');
      var bar = drawer.querySelector('.au-drawer__bar i');
      var shipMsg = drawer.querySelector('[data-au-ship-msg]');
      var threshold = parseInt(drawer.dataset.freeShipping || '0', 10);
      if(threshold > 0 && shipMsg){
        var left = threshold - cart.total_price;
        shipMsg.textContent = left > 0 ? (drawer.dataset.shipLeft || '[amount] away from free shipping').replace('[amount]', money(left)) : (drawer.dataset.shipDone || 'Your order ships free');
        if(bar) bar.style.width = Math.min(100, cart.total_price / threshold * 100) + '%';
      }
      if(!cart.items.length){
        list.innerHTML = '<p class="au-drawer__empty">' + (drawer.dataset.empty || 'Your cart is empty.') + '</p>';
        if(foot) foot.hidden = true;
      } else {
        if(foot) foot.hidden = false;
        list.innerHTML = cart.items.map(function(l){
          var img = l.image ? (l.image + (l.image.indexOf('?')>-1 ? '&' : '?') + 'width=160') : '';
          return '<div class="au-line">' +
            (img ? '<img src="'+img+'" alt="" width="76" height="76" loading="lazy">' : '<span></span>') +
            '<div><div class="au-line__title">'+escapeHtml(l.product_title)+'</div>' +
            (l.variant_title ? '<div class="au-line__variant">'+escapeHtml(l.variant_title)+'</div>' : '') +
            '<div class="au-line__qty"><button type="button" data-key="'+l.key+'" data-q="'+(l.quantity-1)+'" aria-label="Decrease">−</button><span>'+l.quantity+'</span><button type="button" data-key="'+l.key+'" data-q="'+(l.quantity+1)+'" aria-label="Increase">+</button></div><button type="button" class="au-line__remove" data-key="'+l.key+'" data-q="0" aria-label="Remove '+escapeHtml(l.product_title)+'"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12M9 7V4h6v3"/></svg><span>Remove</span></button></div>' +
            '<div class="au-line__price">'+money(l.final_price*l.quantity)+'</div></div>';
        }).join('');
        list.querySelectorAll('button[data-key]').forEach(function(b){
          b.addEventListener('click', function(){ AUCart.change(b.dataset.key, parseInt(b.dataset.q,10)).then(render); });
        });
      }
      if(total) total.textContent = money(cart.total_price);
      return cart;
    });
  }
  function escapeHtml(s){ return String(s||'').replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }

  document.querySelectorAll('[data-au-cart-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); AUCart.open(); }); });
  if(drawer){
    drawer.querySelectorAll('[data-au-cart-close]').forEach(function(b){ b.addEventListener('click', AUCart.close); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') AUCart.close(); });
  }
  /* quick add (cards + drawer upsell) */
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('[data-au-quick-add]') : null;
    if(!b) return;
    e.preventDefault();
    var old = b.textContent; b.disabled = true; b.textContent = '…';
    AUCart.add({ id: parseInt(b.dataset.auQuickAdd, 10), quantity: 1 }).then(function(){ document.dispatchEvent(new CustomEvent('cart:add')); AUCart.open(); })
      .catch(function(err){ alert((err && err.description) || 'Something went wrong. Please try again.'); })
      .finally(function(){ b.disabled = false; b.textContent = old; });
  });
  render();

  /* preview-only newsletter */
  if(PREVIEW){
    document.querySelectorAll('.au-news form').forEach(function(f){
      f.addEventListener('submit', function(e){ e.preventDefault(); var m = f.parentNode.querySelector('.au-news__msg'); if(m){ m.textContent = 'Bedankt! (preview — in Shopify wordt je e-mail echt opgeslagen)'; } });
    });
    document.querySelectorAll('[data-au-checkout]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); alert('Preview: in de Shopify-versie ga je hier naar de echte checkout.'); }); });
  }
})();
